import * as React from "react";
import { useEffect, useState } from "react";
import { useDataProvider } from "react-admin";
import { Typography } from "@material-ui/core";
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Legend, Bar, Tooltip } from "recharts";

const PrematureFailureTrend = ({ filterParams }) => {
  const dataProvider = useDataProvider();

  const [chartData, setChartData] = useState([] as any);

  const resourceEndpoint = "reliabilityprematurefailures/pftrend";

  useEffect(() => {
    GetChartData();
  }, [filterParams]);

  const GetChartData = async () => {
    await dataProvider
      .getList(resourceEndpoint, {
        pagination: { page: 1, perPage: 99999 },
        sort: { field: "id", order: "ASC" },
        filter: filterParams,
      })
      .then(({ data }) => {
        setChartData(data);
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" align="center">
        Premature Failure Trends
      </Typography>
      <div style={{ width: 1200, height: 400 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart barGap={-30} data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <XAxis dataKey="dateMonth" xAxisId={0} />
            <XAxis dataKey="dateMonth" xAxisId={1} hide />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip cursor={false} />
            <Legend />
            <Bar
              dataKey="allPrematureFailureCount"
              barSize={40}
              xAxisId={1}
              fill="#ccc"
              name="Reported Premature Failure Count"
            />
            <Bar
              dataKey="confirmedPrematureFailureCount"
              barSize={20}
              xAxisId={0}
              fill="#F44336"
              fillOpacity={0.7}
              name="Confirmed Premature Failure Count"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default PrematureFailureTrend;
